function hasTextInsideTags(str) {
    const hasText = /<[^>]+>([^<>]+)<\/[^>]+>/.test(str)
    const hasImage = /<img\s[^>]*src=["'][^"']+["'][^>]*>/.test(str)
    return hasText || hasImage
}

export default hasTextInsideTags